<template>
  <div id="loading">
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created() {
     const loading = this.$loading({
      lock: this.$store.state.updateLoading,
      // text: 'Loading',
      // spinner: 'el-icon-loading',
      background: '#fff'
    });
    setTimeout(() => {
      loading.close();
    }, 900);
  },
};
</script>
<style lang="less">

</style>


// WEBPACK FOOTER //
// src/views/loading.vue